import { Operator } from './operators'

export enum DataFieldComponent {
  Unifree = 'Unifree',
  DatePicker = 'DatePicker',
  StandardUniselection = 'StandardUniselection',
  StandardMultiselection = 'StandardMultiselection',
  AutocompleteUniselection = 'AutocompleteUniselection',
  AutocompleteMultiselection = 'AutocompleteMultiselection'
}

export type InterdependentFiltering = {
  uuid: string
  depends_on: string
  disable_on_unfulfilled_dependency?: boolean
}

export type InterdependentFilteringConfig = {
  [fieldName: string]: InterdependentFiltering
}

export type FilteractionsLayout = {
  hide_filters_after_filteraction: boolean
  hide_filteraction?: boolean
}

export type ManagementLineElement = {
  uuid: string
}

export type ManagementLineLayout = {
  left_elements: ManagementLineElement[]
  center_elements: ManagementLineElement[]
  right_elements: ManagementLineElement[]
}

export type DataFieldLayout = {
  component?: DataFieldComponent
  filteraction?: string
  label?: string
  operator?: Operator
}

export type FilterFieldLayout = {
  field_uuid: string
  display_actions: boolean
  datafield?: DataFieldLayout
  width?: string
}

export type FilterSectionLayout = {
  filter_fields: FilterFieldLayout[]
}

// type for layout
type FilterAreaLayout = {
  filteractions?: FilteractionsLayout
  elements?: string[]
  management_lines?: ManagementLineLayout[]
  filter_sections?: FilterSectionLayout[]
  hide_main_collapsible_container?: boolean
  hide_fields_collapsible_container?: boolean
  interdependent_filtering?: InterdependentFilteringConfig
}

export default FilterAreaLayout
